import { Injectable } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { InfoModalComponent } from '../modals/info-modal/info-modal.component';

@Injectable()
export class ModalService {

    constructor(
        private alertController: AlertController,
        private modalCtrl: ModalController
    ) {}

    async createModal({ header, message, icon, buttonText, cssClass }: { [key: string]: string }): Promise<HTMLIonModalElement> {
        return await this.modalCtrl.create({
            component: InfoModalComponent,
            cssClass: cssClass || 'vesta-info-modal',
            backdropDismiss: false,
            componentProps: {
                header: header,
                message: message,
                icon: icon,
                buttonText: buttonText
            }
        });
    }

    async showError(header: string = 'Ooops!', message: string = 'Sorry, something went wrong. Please try again.') {
        const modal = await this.createModal({
            header: header,
            message: message,
            cssClass: 'vesta-error-modal'
        });

        await modal.present();
    }
}
